module.exports = __webpack_public_path__ + "img/ic_main_menu_setting.d0e5a4b4.png";